import { useEffect, useState } from 'react';
import { Image } from '@mantine/core';
import { buildImagePath, createSignedUrl } from '@lib/s3-helper';
import { Choice, Question } from '@generated/graphql';
import classes from './question-thumbnail.module.css';

interface QuestionThumbnailProps {
  item: Question | Choice;
}
function QuestionThumbnail({ item }: QuestionThumbnailProps) {
  const [imageUrl, setImageUrl] = useState<string>();
  const [altText, setAltText] = useState<string>();

  useEffect(() => {
    const makeImageUrl = async () => {
      const key = buildImagePath(item);
      const url = await createSignedUrl(key);
      setImageUrl(url);
      setAltText(item.text);
    };
    makeImageUrl().catch((error) => {
      console.error('Error fetching image URL:', error);
    });
  }, [item]);

  // TODO alt item.text

  return <Image className={classes.thumbnail} src={imageUrl} alt={altText} h={125} w={125} radius="sm" />;
}

export default QuestionThumbnail;
